module.exports = __webpack_public_path__ + "img/PolygonLogo.b011da26.svg";